<template>
  <div class="d-flex cursor-pointer">
    <div class="btn-group ec-ds-scope-dropdown ds-input" role="group"> 
      <button
        class="value-display list-group-item col w-100 d-flex flex-row justify-content-between p-0 align-items-center ec-ds-scope-dropdown-inlay"
        id="btnGroupDrop2"
        type="button"
        data-toggle="dropdown"
        aria-expanded="false"
      >
        <div
          class="pl-2 h-100 d-flex ds-input align-items-center font-weight-bold ec-ds-scope-text"
        >
          {{ $t(currentTextKey) }}
        </div>
        <div class="ecl-select__icon ec-ds-scope-select">
          <svg
            class="ecl-icon ecl-icon--s ecl-icon--rotate-180 ecl-select__icon-shape ec-ds-scope-arrow"
            focusable="false"
            aria-hidden="true"
          >
            <use xlink:href="@/assets/img/ecl/icons.svg#corner-arrow"></use>
          </svg>
        </div>
      </button>
      <ul
        class="dropdown-menu ec-ds-dropdown-items"
        aria-labelledby="btnGroupDrop2"
      >
        <li class="nav-item mb-0" role="tab">
          <router-link
            :to="{ name: 'Datasets', query: { locale: $route.query.locale } }"
            class="nav-link"
            :class="activeClass('dataset')"
            role="presentation"
          >
            {{ $t(textKeys.dataset) }}
          </router-link>
        </li>
        <li class="nav-item mb-0" role="tab">
          <router-link
            :to="{ name: 'Catalogues', query: catalogueRouteQuery() }"
            v-if="useCatalogs"
            class="nav-link"
            :class="activeClass('catalogue')"
            role="presentation"
          >
            {{ $t(textKeys.catalogue) }}
          </router-link>
        </li>
        <li class="nav-item mb-0" role="tab">
          <a
            :href="`/${this.$route.query.locale}/search?term=${
              this.$route.query.query || ''
            }&searchdomain=site`"
            class="nav-link"
            :class="activeClass('editorialContent')"
            role="presentation"
          >
            {{ $t(textKeys.editorialContent) }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchScopeTabs",
  props: {
    config: Object,
  },
  data() {
    return {
      useCatalogs: this.$env.content.datasets.useCatalogs,
      textKeys: {
        dataset: "message.header.navigation.data.datasets",
        catalogue: "message.header.navigation.data.catalogs",
        editorialContent: "message.searchTabs.editorialContent",
      },
    };
  },
  computed: {
    currentTextKey() {
      return this.textKeys[this.config.scope];
    },
  },
  methods: {
    catalogueRouteQuery() {
      if (this.$route.query.superCatalog === "erpd") {
        return { superCatalog: "erpd", locale: this.$route.query.locale };
      } else if (this.$route.path.endsWith("catalogues/erpd")) {
        return {
          superCatalog: "erpd",
          showsubcatalogs: true,
          locale: this.$route.query.locale,
        };
      } else {
        return { locale: this.$route.query.locale };
      }
    },
    activeClass(scope) {
      return scope === this.config.scope
        ? "router-link-active"
        : "router-link-inactive";
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
}

.router-link-active {
  color: #7f7f7f !important;
  border: none !important;
  border-bottom: 2px solid #0e47cb !important;

  &:hover {
    color: #0e47cb !important;
  }
}

.router-link-inactive {
  color: rgba(0, 0, 0, 0.7);
  border: none !important;

  &:hover {
    color: #0e47cb !important;
  }
}

.ec-ds-dropdown-items .nav-item .router-link-inactive.active {
  background-color: #fff !important;
  color: #7f7f7f !important;

  &:hover {
    color: #0e47cb !important;
  }
}

.router-link-inactive.active {
  color: #fff !important;

  &:hover {
    color: #fff !important;
  }
}

.ec-ds-dropdown-items .nav-item .router-link-active {
  background-color: #0e47cb !important;
  color: #fff !important;
}

.ec-ds-dropdown-items .nav-item .router-link-inactive.active {
  background-color: #fff !important;
  color: #7f7f7f !important;

  &:hover {
    color: #0e47cb !important;
  }
}

.ec-ds-dropdown-items .nav-item .router-link-active {
  background-color: #0e47cb !important;
  color: #fff !important;
}

.router-link-active {
  color: #7f7f7f !important;
  border: none !important;
  border-bottom: 2px solid #0e47cb !important;

  &:hover {
    color: #0e47cb !important;
  }
}

@media screen and (max-width: 995.5px) {
  .ec-ds-scope-dropdown {
    max-width: 0;
    min-width: 130px;
  }

  .ec-ds-dropdown-items {
    width: 20px;
  }

  .dropdown-menu {
    min-width: 128px;
  }
}

@media screen and (max-width: 767.5px) {
  .ec-ds-dropdown-items {
    width: 100% !important;
  }

  .ec-ds-scope-dropdown {
    min-width: 100% !important;
  }

  .cursor-pointer {
    margin-top: 10px;
  }

  .ds-input {
    border-radius: 4px !important;
  }

  .value-display {
    border-radius: 4px !important;
  }

  .ecl-select__icon {
    border-radius: 0 4px 4px 0;
  }
}
</style>
